import { render, staticRenderFns } from "./RescuePopup.vue?vue&type=template&id=2247af53&scoped=true&"
import script from "./RescuePopup.vue?vue&type=script&lang=js&"
export * from "./RescuePopup.vue?vue&type=script&lang=js&"
import style0 from "./RescuePopup.vue?vue&type=style&index=0&id=2247af53&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2247af53",
  null
  
)

export default component.exports